import Box from '@mui/material/Box'
import { ErrorWithErrData } from '@cbgms/api'
import { ErrorProviderTooltip } from './search-v1/Results/ErrorProviderTooltip'

export const SilentErrorIcon: React.FC<{ silentErrors: ErrorWithErrData[] }> = ({ silentErrors }) => {
  if (silentErrors) {
    const errors = silentErrors?.map(e => e.Err)
    return (
      <Box display='flex' alignItems='center'>
        <ErrorProviderTooltip errors={errors || []} />
      </Box>
    )
  }
  return null
}
